import config from 'config';
import { IncentiveCampaignType } from 'domains/loyalty';

export type CardInfoType = {
  index: string;
  title: string;
  description: string;
  note?: string;
  optinClosedDescription?: string;
};

export function getCampaignCards(
  isLoyaltyMember: boolean,
  incentiveCampaign: IncentiveCampaignType | undefined,
  isOptinClosed: boolean
): CardInfoType[] {
  if (!incentiveCampaign) {
    return [];
  }

  const cards = [
    {
      index: '1.',
      title: 'Inscrição na campanha',
      description: isOptinClosed
        ? 'A partir do ciclo 3, após a inscrição, já começaram a participar.'
        : 'A partir do ciclo 3, você já começa a participar.',
    },
    {
      index: '2.',
      title: `Premiação TOP ${incentiveCampaign?.limit} ${config.communication.userNamingConvention.plural} por faixa`,
      description: isOptinClosed
        ? 'Puderam ganhar 1 bolsa exclusiva do incentivo e até R$ 1.000 em produtos! Além disso, os TOP VIPs* (rubi, esmeralda e diamante) também concorreram a 1 viagem para Bahia.'
        : 'Poderão ganhar 1 bolsa exclusiva do incentivo e até R$ 1.000 em produtos! Além disso, os TOP VIPs* (rubi, esmeralda e diamante) também concorrem a 1 viagem para Bahia.',
      note: '*Saiba mais e confira vagas por faixa no regulamento do incentivo',
    },
  ];

  if (!isLoyaltyMember) {
    cards.push(
      {
        index: '3.',
        title: 'Compre e ganhe',
        description: isOptinClosed
          ? 'Foram 5 desafios e, de acordo com o desafio atingido, ganharam mais pontos!'
          : 'São 5 desafios e, de acordo com o desafio atingido, você ganha mais pontos!',
      },
      {
        index: '4.',
        title: 'Resgate de recompensas',
        description: isOptinClosed
          ? 'Utilizaram pontos acumulados para resgatar prêmios incríveis!'
          : 'Utilize seus pontos acumulados para resgatar prêmios incríveis!',
      }
    );
    cards[0].description = isOptinClosed
      ? 'A partir do ciclo 3, após a inscrição, já começaram a acumular pontos.'
      : 'A partir do ciclo 3, você já pode começar a acumular pontos.';
  }

  return cards;
}
